import { collection, doc, writeBatch, getDocs } from 'firebase/firestore';
import { getFirebaseDb } from '../firebase/config';
import { DATA_KEY_TO_COLLECTION } from '../firebase/collections';

export function snapDocsToArray(snapshot) {
  return snapshot.docs.map((d) => {
    const data = d.data();
    return { id: d.id, ...data };
  });
}

const BATCH_LIMIT = 400;

/**
 * Syncs an array of objects to a collection: upserts by id, deletes docs missing from the array.
 */
export async function replaceKeyedCollection(collectionName, items) {
  const db = getFirebaseDb();
  const colRef = collection(db, collectionName);
  const existingSnap = await getDocs(colRef);
  const newIds = new Set(items.map((i) => String(i.id)));

  const toDelete = [];
  existingSnap.forEach((d) => {
    if (!newIds.has(d.id)) toDelete.push(d.ref);
  });

  for (let i = 0; i < toDelete.length; i += BATCH_LIMIT) {
    const batch = writeBatch(db);
    toDelete.slice(i, i + BATCH_LIMIT).forEach((ref) => batch.delete(ref));
    await batch.commit();
  }

  for (let i = 0; i < items.length; i += BATCH_LIMIT) {
    const batch = writeBatch(db);
    const chunk = items.slice(i, i + BATCH_LIMIT);
    chunk.forEach((item) => {
      const id = String(item.id);
      const ref = doc(colRef, id);
      const { id: _omit, ...rest } = item;
      batch.set(ref, { ...rest, id }, { merge: true });
    });
    await batch.commit();
  }
}

export async function commitDataKey(dataKey, items) {
  const col = DATA_KEY_TO_COLLECTION[dataKey];
  if (!col) throw new Error(`Unknown data key: ${dataKey}`);
  await replaceKeyedCollection(col, items);
}

export async function commitDataKeys(partial) {
  for (const [key, arr] of Object.entries(partial)) {
    if (Array.isArray(arr)) await commitDataKey(key, arr);
  }
}
